import { useUIOnlyFeatureFlag } from "~/hooks/useUIOnlyFeatureFlag";
export function useIsDashboardVNextEnabled(): boolean {
    const [isDashboardVNextEnabled] = useDashboardVNextFeatureFlag();
    return isDashboardVNextEnabled;
}
export function useDashboardVNextFeatureFlag(): ReturnType<typeof useUIOnlyFeatureFlag> {
    const [uiDashboardVNextFeatureFlagEnabled, setFeatureFlagEnabled] = useUIOnlyFeatureFlag("DashboardVNext", { isInitiallyEnabled: false });
    return [uiDashboardVNextFeatureFlagEnabled, setFeatureFlagEnabled];
}
